import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { ReservationLoaderPage } from '../../../reservation/reservation-loader/reservation-loader';
import { HomePage } from '../../../home/home';

@Component({
  selector: 'page-tutorial-reservas',
  templateUrl: 'tutorial-reservas.html',
})
export class TutorialReservasPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.setRoot(ReservationLoaderPage);
      this.globals.side_menu_active_analytics = false;
    } else {
      this.navCtrl.push(HomePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-reservas/tutorial-reservas.ts